import { CatharsisSymbol, CatharsisFactoryFunctionSymbol } from '@wix/thunderbolt-catharsis'
import type { Bind } from '@wix/thunderbolt-ioc'
import { CatharsisFactory, CatharsisFactoryFunction } from './CatharsisFactory'
import { singleTransactionCatharsisFactory } from './singleTransactionCatharsisFactory'
import type { CatharsisConstants } from './constants'
import { FeaturesCompNodesProvider } from './FeaturesCompNodesProvider'
import { ConstantSymbol, CompNodeProviderSymbol, CatharsisSingleTransactionSymbol } from './symbols'
import type { BindFeature } from './types'

const entries = <T extends Record<string, any>>(obj: T) => Object.entries(obj) as Array<[keyof T, T[keyof T]]>

export const css: BindFeature = (bind: Bind, constants: CatharsisConstants) => {
	entries(constants).forEach(([name, value]) => {
		bind(ConstantSymbol).toConstantValue(value).whenTargetNamed(name)
	})
	bind(CompNodeProviderSymbol).to(FeaturesCompNodesProvider)
	bind(CatharsisSymbol).to(CatharsisFactory)
	bind(CatharsisSingleTransactionSymbol).to(singleTransactionCatharsisFactory)
}

export const editor = (bind: Bind, constants: CatharsisConstants) => {
	entries(constants).forEach(([name, value]) => {
		bind(ConstantSymbol).toConstantValue(value).whenTargetNamed(name)
	})
	bind(CompNodeProviderSymbol).to(FeaturesCompNodesProvider)
	bind(CatharsisSymbol).to(CatharsisFactory)
	bind(CatharsisFactoryFunctionSymbol).to(CatharsisFactoryFunction)
	bind(CatharsisSingleTransactionSymbol).to(singleTransactionCatharsisFactory)
}
